export const shouldShowField = (fieldKey: string, formData: any, creativityType: string): boolean => {
  // Mostrar cta_text solo si cta_enabled está activado
  if (fieldKey === 'cta_text') {
    const ctaEnabled = formData.cta_enabled;

    return ctaEnabled === true || ctaEnabled === 'si';
  }

  // Mostrar subheadline solo si subheadline_enabled está activado
  if (fieldKey === 'subheadline') {
    return formData.subheadline_enabled === true || formData.subheadline_enabled === 'si';
  }

  // Por defecto, mostrar todos los demás campos
  return true;
};
